import axiosInstance from "./axiosInstance";

const chatLimitsService = {
  get: async () => {
    const response = await axiosInstance.get("admin/chat-limits");
    return response.data;
  },
  getOverrides: async (params = {}) => {
    const response = await axiosInstance.get("admin/chat-limits/overrides", { params });
    return response.data;
  },
  updateGlobal: async (payload) => {
    const response = await axiosInstance.put("admin/chat-limits/global", payload);
    return response.data;
  },
  getUser: async (userId) => {
    const response = await axiosInstance.get(`admin/chat-limits/users/${userId}`);
    return response.data;
  },
  upsertUser: async (userId, payload) => {
    const response = await axiosInstance.put(`admin/chat-limits/users/${userId}`, payload);
    return response.data;
  },
  deleteUser: async (userId) => {
    const response = await axiosInstance.delete(`admin/chat-limits/users/${userId}`);
    return response.data;
  },
};

export default chatLimitsService;
